// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1306":"a815abf4ec8f0616","2414":"4672dc89f125d0ee"}[chunkId] + ".css";
};